var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloudPlus = function SvgCloudPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 28,
    fill: "none",
    viewBox: "0 0 29 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m25.042 19.007.018-.018.045-.044c1.468-1.524 2.152-3.748 1.747-5.776-.477-2.419-2.449-4.474-4.898-5.13h-.045l-.126-.035c-.054-.009-.117-.026-.225-.044l-.162-.036-.081-.141-.099-.16C19.938 5.444 17.408 4.018 14.797 4h-.018a7.5 7.5 0 0 0-2.485.407c-2.413.807-4.312 2.897-4.843 5.325l-.018.088-.054.204-.207.053c-1.945.523-3.539 2.09-4.034 4.004-.468 1.816.036 3.686 1.342 5.059l.189.186a6.2 6.2 0 0 0 1.844 1.226c.813.342 2.454.448 2.454.448M17.486 17v7.04M21.007 20.52h-7.04"
  })));
};
export default SvgCloudPlus;